<template>
  <modal :title="$t('customization.editMotif')">
    <alignment-settings-panel :active-element="activeElement" />
    <menu-item to="list-designs" @click.native="trackClick">
      <div class="flex justify-between">
        <div>
          {{ $t('customization.changeMotif') }}
        </div>
      </div>
    </menu-item>
  </modal>
</template>
<script>
import AlignmentSettingsPanel from '../../components/AlignmentSettingsPanel.vue';
import MenuItem from '../../components/MenuItem.vue';
import Modal from '../../components/Modal.vue';
import ActiveElement from '@/mixins/activeElement';
import { TrackingMixin } from '@/mixins/gtm-tracking';

export default {
  name: 'DesignEdit',
  components: {
    AlignmentSettingsPanel,
    MenuItem,
    Modal
  },
  mixins: [ActiveElement, TrackingMixin],
  methods: {
    trackClick() {
      this.trackEvent({ action: 'Motif_Change' });
    }
  }
};
</script>
